import { CombinedPaperTypeAndOrientationSplit } from '../types/combined-paper-type-and-orientation-split.type';
import { CombinedPaperTypeAndOrientation } from '../types/combined-paper-type-and-orientation.type';
import { PaperOrientation } from '../types/paper-orientation.type';

export function transformToPaperOrientation(
  str: CombinedPaperTypeAndOrientation,
): PaperOrientation {
  const [, paperOrientation] = str.split(
    '_',
  ) as CombinedPaperTypeAndOrientationSplit;

  return paperOrientation;
}
